var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.wineMakingNotes.length > 0 || _vm.tastingNotes.length > 0
    ? _c(
        "div",
        { staticClass: "winemaking-notes-section" },
        [
          _c(
            "b-container",
            [
              _c(
                "b-row",
                [
                  _c("b-col", [
                    _c("section", [
                      _vm.wineMakingNotes.length > 0
                        ? _c(
                            "section",
                            { staticClass: "mb-3" },
                            [
                              _c("h2", [_vm._v("Notes")]),
                              _vm._v(" "),
                              _c("wine-making-notes-component", {
                                attrs: {
                                  content: _vm.wineMakingNotes,
                                  map: "winemaking",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.tastingNotes.length > 0
                        ? _c(
                            "section",
                            { staticClass: "mb-3" },
                            [
                              _c("h2", { staticClass: "mt-3" }, [
                                _vm._v("Tasting Notes"),
                              ]),
                              _vm._v(" "),
                              _c("wine-making-notes-component", {
                                attrs: {
                                  content: _vm.tastingNotes,
                                  map: "tasting",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }